import { getDomain } from "@primoui/utils"
import { env } from "~/env"

const indexableHosts = new Set(["webscraping.app", "www.webscraping.app"])
const fallbackSiteUrl = "https://webscraping.app"

const getSafeDomain = (siteUrl: string | undefined) => {
  try {
    return getDomain(siteUrl || fallbackSiteUrl)
  } catch {
    return getDomain(fallbackSiteUrl)
  }
}

const getSiteHostname = (siteUrl: string | undefined) => {
  try {
    return new URL(siteUrl || "").hostname.toLowerCase()
  } catch {
    return null
  }
}

export const siteConfig = {
  name: "webscraping.app",
  slug: "webscraping-app",
  email: env.NEXT_PUBLIC_SITE_EMAIL,
  url: env.NEXT_PUBLIC_SITE_URL,
  domain: getSafeDomain(env.NEXT_PUBLIC_SITE_URL),
}

export function isSearchIndexingEnabled() {
  const hostname = getSiteHostname(siteConfig.url)

  return env.VERCEL_ENV === "production" && hostname !== null && indexableHosts.has(hostname)
}
